var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center"},[_c('h1',[_vm._v("Активная лицензия системы не допускает использование данного справочника")]),_c('h2',[_vm._v("По вопросам приобретения компонентов системы, обратитесь, пожалуйста, к разработчику")])])
}
var staticRenderFns = []

export { render, staticRenderFns }